import React from 'react';

import { KeyOutlined } from '@ant-design/icons';
import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';

const ShoplineCredentials = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Form.Item
        name={['credentials', 'api_key']}
        label={t('models.ec_account.platform_settings.shopline.api_key')}
        rules={[{ required: true, message: t('models.ec_account.platform_settings.shopline.api_key_required') }]}
      >
        <Input.Password
          autoComplete="new-password"
          placeholder={t('models.ec_account.platform_settings.shopline.api_key_placeholder')}
          prefix={<KeyOutlined />}
        />
      </Form.Item>
    </div>
  );
};

export default ShoplineCredentials;
